module.exports = __webpack_public_path__ + "media/images/games/clash-royale/hiw-2-5da1f70e81ed594fb7314543ed3a7ce2.jpg";